module.exports = __webpack_public_path__ + "img/vegetable-salsify-190x100.4329e9dd.jpg";